// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"5a93941d","988":"caaed2dd"}[chunkId] + ".chunk.js";
};